import pclnRequest from '@pcln/request'
import analytics from '@/shared-utils/analytics'
import {
  DealDataMappedType,
  DealDataResponseType
} from '@/components/ScrollableDealModule'
import setDealContent from './set-deal-content'

type PriceCacheSuccessfulResponse = {
  packages: DealDataResponseType[]
  message?: string
}

type InputType = {
  latitude: number
  longitude: number
}

const PACKAGE_PRICE_CACHE_ENDPOINT = '/pws/v0/psapi/search/pricecache'

const fecthDataFromPriceCache = async ({
  latitude,
  longitude
}: InputType): Promise<DealDataResponseType[]> => {
  const queryString = `?latitude=${latitude}&longitude=${longitude}`
  const url = `${PACKAGE_PRICE_CACHE_ENDPOINT}${queryString}`

  const result = await pclnRequest({
    url,
    method: 'GET',
    headers: {
      'Cache-Control': 'private, max-age=900'
    }
  })

  const { packages, message }: PriceCacheSuccessfulResponse = result?.data || {}

  if (message) {
    throw new Error(
      `Error in getPriceCache query response: ${JSON.stringify(message)}`
    )
  }

  return packages
}

const getPriceCache = async ({
  latitude,
  longitude
}: InputType): Promise<DealDataMappedType[]> => {
  try {
    const bundles = await fecthDataFromPriceCache({ latitude, longitude })

    return setDealContent(bundles)
  } catch (error) {
    let errorMessage: string = (error as Error).message

    errorMessage =
      'Failed to call Price Cache api!\n' +
      `lat: ${Number(latitude)}\n` +
      `lon: ${Number(longitude)}\n` +
      `message: ${errorMessage}`

    analytics.logError({ message: errorMessage })
    return []
  }
}

export default getPriceCache
